// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUpPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import Header from "./components/Header";
import EmailVerifiedPage from "./pages/EmailVerifiedPage";
import SetNewPasswordPage from './pages/SetNewPasswordPage';
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import DashboardPage from "./pages/DashboardPage";
import ProtectedRoute from "./components/ProtectedRoute";
import EventPage from "./pages/EventPage";
import GuestListPage from './pages/GuestListPage';
import InvitationsPage from './pages/InvitationsPage';
import InviteLinkPage from "./pages/InviteLinkPage";
import WorkerRegisterPage from "./pages/WorkerRegisterPage";
import WorkerDashboard from "./pages/WorkerDashboard";
import WorkerGuestListPage from "./pages/WorkerGuestListPage";
import SettingsPage from "./pages/SettingsPage";
import PeoplePage from "./pages/PeoplePage";
import PermanentGuestListPage from "./pages/PermanentGuestListPage";
import GuestsPeoplePage from "./pages/GuestsPeoplePage";
import PermanentInvitationsPeoplePage from "./pages/PermanentInvitationsPeoplePage";
import PermanentInvitationsPage from "./pages/PermanentInvitationsPage";
import { AuthProvider } from './context/AuthContext';
import StatisticsPage from './pages/StatisticsPage';
import AdminDashboard from './pages/AdminDashboard';
import SubscriptionPage from './pages/SubscriptionPage'; // Добавляем импорт страницы подписки

function AppContent() {
    const location = useLocation();
    const shouldRenderHeader = location.pathname !== '/'; // Check if NOT homepage

    return (
        <>
            {shouldRenderHeader && <Header />} {/* Conditionally render Header */}
            <ToastContainer
                position="bottom-right"
                autoClose={1000}
                hideProgressBar
                closeOnClick
                pauseOnHover
                draggable
                theme="colored"
            />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/signup" element={<SignUpPage />} />
                <Route path="/reset-password" element={<ResetPasswordPage />} />
                <Route path="/email-verified" element={<EmailVerifiedPage />} />
                <Route path="/set-new-password" element={<SetNewPasswordPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/worker/register" element={<WorkerRegisterPage />} />
                <Route path="/subscription" element={<ProtectedRoute element={<SubscriptionPage />} />} /> {/* Добавляем страницу подписки */}

                {/* Маршрут для административной панели */}
                <Route 
                    path="/c7d01" 
                    element={<ProtectedRoute allowedRoles={["admin"]} element={<AdminDashboard />} />} 
                />

                {/* Защищённые маршруты */}
                {/* ИЗМЕНЕНО: Дашборд теперь требует подписку */}
                <Route path="/dashboard" element={<ProtectedRoute requireSubscription={true} element={<DashboardPage />} />} />
                <Route path="/events/:id" element={<ProtectedRoute requireSubscription={true} element={<EventPage />} />} />
                <Route path="/events/:id/guest-list" element={<ProtectedRoute requireSubscription={true} element={<GuestListPage />} />} />
                <Route path="/events/:id/invitations" element={<ProtectedRoute requireSubscription={true} element={<InvitationsPage />} />} />
                
                {/* Премиум-функции, требующие подписку */}
                <Route 
                    path="/statistics" 
                    element={<ProtectedRoute allowedRoles={["admin", "organizer"]} requireSubscription={true} element={<StatisticsPage />} />}
                />
                <Route path="/invite/:token" element={<InviteLinkPage />} />
                <Route
                    path="/worker-dashboard"
                    element={<ProtectedRoute allowedRoles={["worker"]} requireSubscription={true} element={<WorkerDashboard />} />}
                />
                <Route
                    path="/worker/events/:id/guest-list"
                    element={
                        <ProtectedRoute allowedRoles={["worker"]} requireSubscription={true} element={<WorkerGuestListPage />} />
                    }
                />
                {/* Settings остается доступным без подписки */}
                <Route path="/settings" element={<ProtectedRoute allowedRoles={["organizer", "worker", "admin"]} element={<SettingsPage />} />}/>
                
                {/* Премиум-функции: управление людьми и списками */}
                <Route
                    path="/people"
                    element={<ProtectedRoute allowedRoles={["organizer"]} requireSubscription={true} element={<PeoplePage />} />}
                />
                <Route 
                    path="/permanent-guest-lists" 
                    element={<ProtectedRoute allowedRoles={["organizer"]} requireSubscription={true} element={<GuestsPeoplePage />} />} 
                />
                <Route 
                    path="/permanent-guest-lists/:list_id" 
                    element={<ProtectedRoute allowedRoles={["organizer"]} requireSubscription={true} element={<PermanentGuestListPage />} />} 
                />

                {/* Премиум-функции: постоянные списки приглашений */}
                <Route
                  path="/permanent-invitation-lists"
                  element={<ProtectedRoute allowedRoles={["organizer"]} requireSubscription={true} element={<PermanentInvitationsPeoplePage />} />}
                />
                <Route
                  path="/permanent-invitation-lists/:listId/invitations"
                  element={<ProtectedRoute allowedRoles={["organizer"]} requireSubscription={true} element={<PermanentInvitationsPage />} />}
                />
            </Routes>
        </>
    );
}


function App() {
    return (
        <Router>
            <AuthProvider> {/* AuthProvider оборачивает AppContent */}
                <AppContent />
            </AuthProvider>
        </Router>
    );
}


export default App;
